// extracted by mini-css-extract-plugin
export var pillWrapper = "_r6-0";
export var showOverflow = "_r6-1";